import React from "react";
import "../styling/RealEstate.css";

const RealEstate = () => {
  return (
    <div className="realestate-container">
      <h1>Rental Estate Agency</h1>

      {/* Renters Section */}
      <section>
        <h2>For Renters</h2>
        <p>
          VOETA offers a wide variety of rental properties available across the DRC — all conveniently accessible through our mobile app. Whether you're looking for a short-term stay or a long-term lease, we've got you covered with:
        </p>
        <ul>
          <li>Fully furnished apartments</li>
          <li>Private houses or villas</li>
          <li>Shared rooms or co-living spaces</li>
          <li>Commercial office spaces</li>
        </ul>
        <p>
          All listings are thoroughly verified, updated regularly, and supported by our dedicated customer service team. Tenants benefit from direct communication through our in-app chat for fast, reliable support.
        </p>
        <div className="cta">
          📱 <strong>Browse all available properties through the VOETA Mobile App</strong>
        </div>
      </section>

      {/* Landlords Section */}
      <section>
        <h2>For Landlords</h2>
        <p>
          Looking to rent out your property in the DRC? VOETA offers full-service property management solutions — from tenant sourcing and screening to contract administration, rent collection, and maintenance coordination.
        </p>
        <p>We work with property owners offering:</p>
        <ul>
          <li>Apartments and residential units</li>
          <li>Commercial buildings and office spaces</li>
          <li>Rooms or shared spaces for co-living</li>
          <li>Short-term and long-term rental units</li>
        </ul>
        <p>
          Your property will be promoted directly on our VOETA mobile app, increasing visibility to qualified tenants across the region.
        </p>

        {/* New Insurance Section */}
        <p>
          <strong>Property Protection:</strong> VOETA offers <strong>Full and Half Coverage Insurance</strong> options for landlords. In the event of accidental or intentional damage to your property while under our management, we coordinate all necessary repairs or replacements — giving you complete peace of mind.
        </p>
        <ul>
          <li><strong>Full Coverage:</strong> 100% repair or replacement costs for covered damages.</li>
          <li><strong>Half Coverage:</strong> Shared cost of repairs between VOETA and the property owner.</li>
          <li>All claims are handled directly through our support and maintenance team.</li>
        </ul>

        <div className="cta">
          🤝 <strong>Request a management contract today — protect and grow your rental income with VOETA</strong>
        </div>
      </section>

      {/* Why VOETA Section */}
      <section>
        <h2>Why VOETA?</h2>
        <ul>
          <li>Verified property listings and quality assurance</li>
          <li>Seamless in-app communication between all parties</li>
          <li>Expert legal and contract support</li>
          <li>Active tenant support and property maintenance</li>
          <li>Optional damage insurance coverage for added protection</li>
        </ul>
      </section>
    </div>
  );
};

export default RealEstate;
